import pickBy from 'lodash/pickBy';
import {
  ORG_SIZE_DEFAULT_MAX,
  ORG_SIZE_DEFAULT_MIN,
  DEFAULT_PAGE_SIZE,
} from '../constants/organization_search.constants';

/**
 * Given an array of locations, map those locations to send them to BE
 *
 * @param {Array} locations - Array for office locations
 * @returns {object} - Returned object only contains truthy key/value pairs
 */
const mapOfficeLocationsForApi = (locations) =>
  locations.reduce((result, location, index) => {
    result[index] = {
      place_key: location.place_key,
      name: location.name,
    };
    return result;
  }, {});

/**
 * Given a series of arguments that can be falsey, generates object that only contains truthy
 * key/values pairs
 *
 * @param {object} [filters] - query params
 * @param {string|undefined} filters.query - Keyword query as string
 * @param {Array|null|undefined} filters.types - types as array
 * @param {number} filters.pageNumber - Number of the page to be queried
 * @param {string|undefined} filters.hiringNow - String to know if org is hiring
 *                                               ('true' or 'false' or undefined)
 * @param {string|undefined} filters.topEmployers - String to know if Top Employers filter
 *                                               is active ('true' or 'false' or undefined)
 * @param {Array|null|undefined} filters.hiringLocations - Office locations as array
 * @param {string|undefined} filters.orgSizeMin - Minimum size of org
 * @param {string|undefined} filters.orgSizeMax - Maximum size of org
 * @param {Array|undefined} filters.officeLocations - Array for office locations
 *
 * @returns {object} - Returned object only contains truthy key/value pairs
 */
const parseQueryParamsForApi = ({
  query = '',
  types,
  pageNumber,
  hiringNow,
  topEmployers,
  hiringLocations,
  orgSizeMin = '',
  orgSizeMax = '',
  officeLocations,
}) => {
  const rootParams = pickBy({
    query: query ? [query] : null,
    page: { number: pageNumber, size: DEFAULT_PAGE_SIZE },
  });

  let nonRootParams = pickBy({
    types: types?.length ? types : null,
    hiring_locations: hiringLocations?.length ? hiringLocations : null,
    hiring_now: hiringNow === 'true',
    top_employers_only: topEmployers === 'true',
    office_locations: officeLocations?.length ? mapOfficeLocationsForApi(officeLocations) : null,
  });

  if (
    (orgSizeMin && orgSizeMin !== ORG_SIZE_DEFAULT_MIN.text) ||
    (orgSizeMax && orgSizeMax !== ORG_SIZE_DEFAULT_MAX.text)
  ) {
    const organization_size = pickBy({
      min: orgSizeMin,
      max: orgSizeMax,
    });

    nonRootParams = pickBy({
      ...nonRootParams,
      organization_size,
    });
  }

  if (Object.keys(nonRootParams).length) {
    return {
      ...rootParams,
      filter: nonRootParams,
    };
  }

  return rootParams;
};

export { parseQueryParamsForApi };
